import { ReactQuillProps, UnprivilegedEditor } from 'react-quill';
import { DeltaStatic, Sources } from 'quill';
import 'react-quill/dist/quill.snow.css';
import { modules, formats } from './config';
import { StyledReactQuill } from './TextEditorStyles';
import { useState, useEffect } from 'react';

const TextEditor = ({ onChange, value, ...props }: ReactQuillProps) => {
  const initialValue = typeof value === 'string' ? value : '';
  const [editorValue, setEditorValue] = useState<string>(initialValue);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setIsReady(true);
  }, []);

  useEffect(() => {
    if (typeof value === 'string' && value !== editorValue) {
      setEditorValue(value);
    }
  }, [value]);

  const handleChange = (newValue: string, delta: DeltaStatic, source: Sources, editor: UnprivilegedEditor) => {
    if (source === 'user') {
      onChange?.(newValue, delta, source, editor);
      setEditorValue(newValue);
    }
  };

  if (!isReady) {
    return null;
  }

  return (
    <StyledReactQuill
      {...props}
      value={editorValue}
      theme="snow"
      onChange={handleChange}
      modules={modules}
      formats={formats}
    />
  );
};

export default TextEditor;
